<template>
  <div>
    <div class="mb-10 filter-mark">红色代表出库状态为“待定” 且 采购状态为“无需采购” 或“已入库”物料，蓝色代表出库状态为“待定” 且 采购状态为非“无需采购”且“已入库”物料</div>
    <el-table
      :data="tableData"
      border
      style="width: 100%;"
      max-height="400px"
      :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
      stripe
      :row-class-name="tableRowClassName"
    >
      <el-table-column label="采购状态" prop="purchaseStatusValue" />
      <el-table-column label="状态" prop="statusValue" />
      <el-table-column label="物料名称" prop="name" min-width="120" show-overflow-tooltip>
        <template #default="{ row }">
          {{row.material.name}}
        </template>
      </el-table-column>
      <el-table-column label="物料型号" prop="model" min-width="120" show-overflow-tooltip>
        <template #default="{ row }">
          {{row.material.model}}
        </template>
      </el-table-column>
      <el-table-column label="数量" prop="num" min-width="80" />
      <el-table-column label="申请原因" prop="des" min-width="120" />
      <el-table-column label="位置" prop="location" min-width="120" >
        <template #default="{ row }">
          {{row.location?.location}}
        </template>
      </el-table-column>
      <el-table-column label="出库审批人" prop="approveUserName" min-width="120" />
      <el-table-column label="出库审批时间" prop="approveTime" min-width="120" />
      <el-table-column label="归还审批人" prop="backUserName" min-width="120" />
      <el-table-column label="归还审批时间" prop="backTime" min-width="120" />
      <el-table-column label="创建时间" prop="createTime" width="140" />
      <el-table-column label="物料编号" prop="no" min-width="120" >
        <template #default="{ row }">
          {{row.material.no}}
        </template>
      </el-table-column>
      <el-table-column label="物料单位" prop="materialUnit" min-width="80" >
        <template #default="{ row }">
          {{row.material.materialUnit}}
        </template>
      </el-table-column>
      <el-table-column label="物料类别" prop="materialClass" min-width="80" show-overflow-tooltip>
        <template #default="{ row }">
          {{row.material.materialClass}}
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="materialMark" min-width="120" show-overflow-tooltip>
        <template #default="{ row }">
          {{row.material.mark}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        width="140"
      >
        <template #default="{ row }">
          <!-- <el-link
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('detail',row)"
          >
            明细
          </el-link> -->
           <el-link
           v-if="(row.purchaseStatusValue === '无需采购' || row.purchaseStatusValue === '已入库') && row.statusValue === '待定'"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('deliver-comfirm', row)"
          >
            出库
          </el-link>
           <!-- <el-link
            v-if="row.statusValue === '待定'"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('delete',row)"
          >
            删除
          </el-link> -->
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-model="dialogVisible"
      title="明细列表"
      width="70%"
    >
      <el-table :data="deliverTableData" border style="width: 100%;" max-height="400px" :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }" stripe>
        <el-table-column label="采购状态" prop="purchaseStatusValue" />
        <el-table-column label="状态" prop="statusValue" />
        <el-table-column label="数量" prop="num" min-width="120" />
        <el-table-column label="物料编号" prop="no" min-width="120" >
          <template #default="{ row }">
             {{row.material.no}}
            </template>
        </el-table-column>
         <el-table-column label="物料名称" prop="name" min-width="120" >
          <template #default="{ row }">
             {{row.material.name}}
            </template>
        </el-table-column>
        <el-table-column label="物料型号" prop="model" min-width="120" >
          <template #default="{ row }">
             {{row.material.model}}
            </template>
        </el-table-column>
        <el-table-column label="申请数量" prop="model" min-width="120" >
          <template #default="{ row }">
            {{row.num}}
          </template>
        </el-table-column>
        <el-table-column label="物料单位" prop="materialUnit" min-width="120" >
          <template #default="{ row }">
            {{row.material.materialUnit}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
           width="120"
        >
        <template #default="{ row }">
          <el-link
            v-if="row.statusValue === '待确认' && !row.locationId"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('deliver', row)"
          >
            预出库
          </el-link>
          <el-link
            v-if="row.statusValue === '待确认'"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('delete', row)"
          >
            删除
          </el-link>
        </template>
      </el-table-column>
      </el-table>
      <template #footer>
        <div class="dialog-footer" style="text-align:right">
          <el-button @click="dialogVisible = false"> 关闭</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog
      v-model="deliverVisible"
      :title="isDeliverComfirm ? '出库' : '预出库'"
      width="70%"
    >
    <div class="form-title mb-10 mt-10">
      <span class="left">物料信息</span>
    </div>
    <el-descriptions >
      <el-descriptions-item label="物料编号：">{{activeRow.material.no}}</el-descriptions-item>
      <el-descriptions-item label="物料名称：">{{activeRow.material.name}}</el-descriptions-item>
      <el-descriptions-item label="物料型号：">{{activeRow.material.model}}</el-descriptions-item>
      <el-descriptions-item label="物料单位：">{{activeRow.material.materialUnit}}</el-descriptions-item>
      <el-descriptions-item label="物料类别：">{{activeRow.materialClass}}</el-descriptions-item>
      <el-descriptions-item label="数量：">{{activeRow.num}}</el-descriptions-item>
    </el-descriptions>
      <el-form
        ref="dataForm"
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="mb-20"
      >
        <div class="underlineForm">
          <el-form-item label="数量" prop="num">
            <el-input v-model="ruleForm.num" type="number" :min="0" :max="activeRow.num"></el-input>
          </el-form-item>
          <el-form-item label="位置" prop="locationId">
            <el-select :filterable="true" v-model="ruleForm.locationId" class="filter-item" placeholder="输入关键字搜索" clearable :size="t('table.btnSize')">
              <el-option
                v-for="item in locationOption"
                :key="item.locationId"
                :label="item.location?.location"
                :value="item.locationId"
              />
            </el-select>
          </el-form-item>
        </div>
        <div class="dialog-footer mt-20 " style="text-align:right">
          <el-button @click="deliverVisible = false" >
            {{ t("table.cancel") }}
          </el-button>
          <el-button
            type="primary"
            @click="isDeliverComfirm ? handleDeliverComfirm() : handleDeliver()"
          >
            {{ t("table.confirm") }}
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, onMounted, watch, ref, unref } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
import { getPageList } from '@/apis/Form'
import { ElMessage, ElMessageBox, ElForm } from 'element-plus'
import { deleteById, putUrl } from '@/apis/Dictionary'

import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'DeliverTable',
  components: {
  },
  props: {
    id: { type: Number, required: true, default: 0 }
  },
  setup(props) {
    const { t } = useI18n()
    const dataForm = ref(ElForm)

    const dataMap = reactive({
      tableData: [],
      deliverTableData: [],
      locationOption: [],
      dialogVisible: false,
      deliverVisible: false,
      deliverConfirmVisible: false,
      activeMateiral: {} as any,
      activeRow: {} as any,
      isDeliverComfirm: false,
      materialId: 0 as any,
      ruleForm: {
        num: null,
        locationId: null
      },
      rules: {
        locationId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        num: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      async getList() {
        dataMap.tableData = await getPageList(`storage/findMaterialDeliveryDetailByBusinessId/${props.id}`)
      },
      handleCommand(command: string, row: any) {
        switch (command) {
          case 'detail':
            dataMap.handleDeliverDetail(row)
            break
          case 'deliver':
            dataMap.deliverVisible = true
            dataMap.activeMateiral = row
            dataMap.materialId = row.materialId
            dataMap.ruleForm = {
              num: dataMap.activeRow.num,
              locationId: null
            }
            break
          case 'delete':
            dataMap.handleDelete(row)
            break
          case 'deliver-comfirm':
            dataMap.activeRow = row
            dataMap.materialId = row.materialId
            dataMap.getLocationOption()
            dataMap.ruleForm = {
              num: dataMap.activeRow.num,
              locationId: null
            }
            dataMap.deliverVisible = true
            dataMap.isDeliverComfirm = true
            break
        }
      },
      async handleDeliverDetail(row: any) {
        const result = await getPageList(`storage/materialDeliveryInfo/${row.materialDeliveryId}`)
        dataMap.deliverTableData = result.details || []
        dataMap.dialogVisible = true
      },
      handleDeliver() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            const params = {
              materialId: dataMap.activeMateiral.materialId,
              ...dataMap.ruleForm
            }
            if (!params.num) {
              return ElMessage.error('数量不得为0！')
            }
            if (Number(params.num) > dataMap.activeRow.num) {
              return ElMessage.error('数量不得大于原本数量！')
            }
            putUrl(`storage/completionMaterialDelivery/${dataMap.activeMateiral.materialDeliveryId}`, params).then((response) => {
              dataMap.getList()
              if (response.hasPurchase) {
                ElMessage.info('库存不足，将自动生成预采购单！')
              } else {
                ElMessage({
                  message: '出库成功',
                  type: 'success',
                  duration: 2000
                })
              }
            })
          }
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('storage/removeMaterialDelivery', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      getLocationOption() {
        getPageList(`storage/storage/${dataMap.materialId}`).then((res: any) => {
          dataMap.locationOption = res || []
          dataMap.ruleForm.locationId = res[0]?.locationId
        })
      },
      handleDeliverComfirm() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            const params = {
              materialId: dataMap.activeRow.id,
              ...dataMap.ruleForm
            }
            if (!params.num) {
              return ElMessage.error('数量不得为0！')
            }
            if (Number(params.num) > dataMap.activeRow.num) {
              return ElMessage.error('数量不得大于原本数量！')
            }
            putUrl(`storage/completionMaterialDelivery/${dataMap.activeRow.id}`, params).then((response) => {
              dataMap.getList()
              dataMap.deliverVisible = false
              if (response.hasPurchase) {
                ElMessage.info('库存不足，将自动生成预采购单！')
              } else {
                ElMessage({
                  message: '出库成功',
                  type: 'success',
                  duration: 2000
                })
              }
            })
          }
        })
      },
      tableRowClassName({ row }: any) {
        const { statusValue, purchaseStatusValue } = row
        if (['采购人员退回', '管理员退回'].includes(purchaseStatusValue)) {
          return 'row-gray'
        }
        if (statusValue === '待定' && ['无需采购', '已入库'].includes(purchaseStatusValue)) {
          return 'row-red'
        }
        if (statusValue === '待定' && !['无需采购', '已入库'].includes(purchaseStatusValue)) {
          return 'row-red'
        }
      }
    })

    watch(() => props.id, () => {
      dataMap.getList()
    }, { immediate: true })

    onMounted(async() => {
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap), dataForm }
  }
})
</script>
